import { COUNTRIES } from '@/constants/dashboard'

export type CustomerField = 'name' | 'email' | 'planId' | 'country'

export type CustomerFieldErrors = Partial<Record<CustomerField, string>>

export interface CustomerFormValues {
    name: string
    email: string
    planId: string
    country: string
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const normalizeCustomerForm = (values: Partial<Record<CustomerField, unknown>>): CustomerFormValues => ({
    name: typeof values.name === 'string' ? values.name.trim().replace(/\s+/g, ' ') : '',
    email: typeof values.email === 'string' ? values.email.trim().toLowerCase() : '',
    planId: typeof values.planId === 'string' ? values.planId.trim() : '',
    country: typeof values.country === 'string' ? values.country.trim() : ''
})

/** Shared by the form and the API, so both always agree on what is valid. */
export const validateCustomerForm = (values: CustomerFormValues): CustomerFieldErrors => {
    const errors: CustomerFieldErrors = {}

    if (values.name.length < 2) errors.name = 'Enter the company name.'
    else if (values.name.length > 80) errors.name = 'Keep the name under 80 characters.'

    if (!EMAIL_PATTERN.test(values.email) || values.email.length > 254) errors.email = 'Enter a valid email address.'

    if (!values.planId) errors.planId = 'Choose a plan.'

    if (!COUNTRIES.includes(values.country)) errors.country = 'Choose a country.'

    return errors
}
